// user Action
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
// verify user for registration action
export const VERIFY_USER = "VERIFY_USER";
export const CLEAR_VERIFY = "CLEAR_VERIFY";
